export const FirebaseConfig = {
	"projectId": "appnvcity",
	"appId": "1:944606915718:web:8a16aa2023f7be6bbff507",
	"databaseURL": "https://appnvcity-default-rtdb.firebaseio.com",
	"storageBucket": "appnvcity.firebasestorage.app",
	"apiKey": "AIzaSyCINRgpsPht0SIdFbgxbdKqbgFTrO2sZjg",
	"authDomain": "appnvcity.firebaseapp.com",
	"messagingSenderId": "944606915718",
	"measurementId": "G-ZY0GHW5PMP",
	"projectNumber": "944606915718",
	"version": "2"
};